import { PaymentMethod, AdyenPaymentMethod } from '../types';
export function getAdyenPaymentMethod(appliedPaymentMethod) {
    if (appliedPaymentMethod === PaymentMethod.Eft) {
        return AdyenPaymentMethod.Eft;
    }
    if (appliedPaymentMethod === PaymentMethod.Ach) {
        return AdyenPaymentMethod.Ach;
    }
    if (appliedPaymentMethod === PaymentMethod.Card) {
        return AdyenPaymentMethod.Card;
    }
    return null;
}
//# sourceMappingURL=getAdyenPaymentMethod.js.map